<i18n>
{
  "en": {
    "title": "Research & Development Highlights 2017-2018",
    "description": "Schneider Electric research and development is empowered by more than 8,000 engineers worldwide, our Digital Services Factory, and our Digital Alliance Partners. This collaborative approach delivers the connected solutions customers need to thrive in today’s digital economy.",
    "sustainable": {
      "section": "Sustainable Solutions",
      "title": "Research & Development",
      "research": {
        "quote1": {
          "text": "Digital innovation is really about solving real customer problems. To do so, you need to have an open ecosystem of technology partners, system integrators, customers, startups, and universities to accelerate and scale innovation.",
          "author": "Cyril Perducat",
          "title": "Executive Vice President, IoT & Digital Offers, Schneider Electric"
        },
        "txtmedia1": {
          "title": "Open innovation for digital transformation",
          "para1": "Empowered by more than 8,000 research and development engineers worldwide, we bring bold ideas to life by developing connected, efficient, and sustainable products and solutions that address customers’ top digital transformation challenges. ",
          "para2": "Working together is the only way to fuel and advance digital innovation, so we’ve built an ecosystem that comprises customers, system integrators, startups, and best-in-class technology partners. Every project begins with one question: How can we solve the specific customer problem before us quickly and at scale?",
          "para3": "With this collaborative approach, we gain speed and agility, thereby expanding our innovation playing field to deliver the new capabilities our customers need to thrive in today’s digital economy."
        },
        "snapshot": {
          "title": "Highlight: Schneider Electric R&D",
          "cell1": {
            "title": "16,250",
            "para": "patents or patent applications"
          },
          "cell2": {
            "title": "670",
            "para": "new patent assets in 2017"
          },
          "cell3": {
            "title": "20+",
            "para": "digital services in development for 2018"
          },
          "cell4": {
            "title": "5%",
            "para": "of sales devoted to R&D"
          }
        },
        "txtmedia2": {
          "title": "Six digital foundations are driving our success in the digital space:",
          "para1": "Schneider is leading the digital transformation of energy management and automation with: ",
          "listItem1": "One IoT-ready architecture and platform, EcoStruxure<sup>&trade;</sup>",
          "listItem2": "Historical leadership at the edge, where operational technology and IT can converge securely to deliver fast, accurate intelligence at the edge",
          "listItem3": "Digital life-cycle management, meaning that we apply IoT advancements to drive down cost and complexity across both CapEx stages (Design and Build) and OpEx stages (Operate and Maintain) ",
          "listItem4": "Deep domain and segment expertise, which enables us to advance digitization that connects expertise to technology in order to solve specific customer problems ",
          "listItem5": "A robust, active digital services portfolio, which amplifies the value we offer customers through services such as Resource Advisor to track and improve energy spend and Asset Advisor to improve asset health and performance",
          "listItem6": "An open partner ecosystem, which allows us to scale and accelerate each customer’s digital journey by working with other best-in-class technology partners such as Microsoft<sup>&reg;</sup>, Accenture<sup>&reg;</sup>, Intel<sup>&reg;</sup>, Cisco<sup>&reg;</sup>, and Salesforce — as well as universities, startups, system integrators, and customers — to develop additional digital solutions quickly"
        },
        "barometer": {
          "title": "2015 – 2017 Planet <span class='t-nowrap'>&amp; Society</span> barometer achievement",
          "cta": "See the full results",
          "cell1": {
            "title": "Circular Economy",
            "stat": "100%",
            "para": "of products in R&amp;D designed with Schneider ecoDesign Way&trade;"
          }
        },
        "table1": {
          "title": "Highlight: Strategic digital alliances",
          "row1": {
            "cell1": "Microsoft",
            "cell2": "Microsoft<sup>&trade;</sup> and Schneider create commercial IoT solutions in the areas of energy management and automation, marrying Microsoft's secure, trusted cloud capabilities and Schneider's OT domain expertise."
          },
          "row2": {
            "cell1": "Cisco",
            "cell2": "Schneider and Cisco develop advanced automation architectures across end-markets, merging Schneider’s operational technology leadership and Cisco’s world-class knowledge of networking and communication solutions."
          },
          "row3": {
            "cell1": "Intel",
            "cell2": "With funding from the U.S. Department of Energy, Schneider and Intel research, develop, and commercialize silicon-based cyber security solutions for the electrical grid."
          },
          "row4": {
            "cell1": "Salesforce",
            "cell2": "Schneider and Salesforce work as partners to leverage connectivity and IoT to create more engaging customer experiences."
          },
          "row5": {
            "cell1": "Accenture",
            "cell2": "Schneider and Accenture are working to cut digital-offer development time-to-market by 80 percent, so customers can achieve their digital transformation and gain improved efficiency, sustainability, and productivity."
          }
        },
        "quote2": {
          "text": "It's amazing to see the solution [WaterForce SCADAfarm] that Schneider has built and what it can do for us as a society. ",
          "author": "Satya Nadella",
          "title": "CEO,",
          "company": "Microsoft, at the 2017 Microsoft Inspire conference"
        },
        "txtmedia3": {
          "title": "Co-innovating with digital alliance partners",
          "para1": "With our network of best-in-class digital technology leaders, we co-innovate digital solutions that:",
          "listItem1": "Respond effectively and quickly to market trends and customer needs",
          "listItem2": "Innovate in a way that benefits the bottom line for business — not just innovation for innovation’s sake",
          "listItem3": "Leverage technology advancements such as sensing, mobility, cloud, analytics, and cyber security so customers can compete in the digital economy, not simply keep up"
        },
        "quote3": {
          "text": "Analytics-based insights are helping Schneider Electric to be more responsive to — or even anticipate — customer needs. New smart digital services, such as predictive maintenance, asset monitoring, and energy optimization help customer operations become more proactive and efficient.",
          "author": "Jean Cabanes",
          "title": "Managing Director, Industrial EALA Lead,",
          "company": "Accenture"
        },
        "txtmedia4": {
          "title": "Digital Services Factory: Speeding up innovation",
          "para1": "Market trends are ever-changing. An accelerated development life cycle is essential for helping customers keep up in order to compete in today’s digital economy. Schneider Electric's Digital Services Factory (DSF) supported by Accenture is the answer. The DSF is a set of capabilities across several Schneider Electric teams, organized to accelerate the creation of new digital services and connected products within Schneider businesses.",
          "para2":"DSF capitalizes on the following expertise of our IoT & Digital Offers organization:",
          "listItem1": "Pervasive sensing",
          "listItem2": "Cyber security",
          "listItem3": "Device intelligence ",
          "listItem4": "Analytics",
          "listItem5": "Digital services",
          "listItem6": "Mission-critical control at the edge"
        },
        "txt": {
          "title": "The Aster Capital Fund",
          "para1": "We invest in innovative startups through the Aster Capital Fund, a leading venture capital firm that specializes in the energy, mobility, and industry fields. This venture capital activity focuses on attractive innovation hubs (North America, Europe, China, and Israel) and has supported over 55 early-stage companies since its inception.",
          "para2": "In 2017, as part of the Innovation at the Edge strategy, Aster supported the design and activation of a business incubation model to bring additional innovation and growth to Schneider Electric. This business incubation initiative allows employees to propose new ideas, setting the foundation for growth for Schneider Electric in new and critical areas."
        }
      }
    }
  },
  "fr": {
    "title": "Research & Development Highlights 2017-2018",
    "description": "Schneider Electric research and development is empowered by more than 8,000 engineers worldwide, our Digital Services Factory, and our Digital Alliance Partners. This collaborative approach delivers the connected solutions customers need to thrive in today’s digital economy.",
    "sustainable": {
      "section": "Des Solutions Durables",
      "title": "Recherche et Développement",
      "research": {
        "quote1": {
          "text": "L'innovation numérique s'attaque aux vrais problèmes des clients. Et pour les résoudre, il est indispensable de disposer d'un écosystème ouvert de partenaires technologiques, d'intégrateurs de systèmes, de clients, de start-up et d'universités afin d'accélerer et de faire évoluer l'innovation",
          "author": "Cyril Perducat",
          "title": "Directeur de la stratégie IoT, Schneider Electric"
        },
        "txtmedia1": {
          "title": "Une innovation ouverte au service de  la transformation numérique",
          "para1": "Fort de plus de 8 000 ingénieurs en recherche et développement à travers le monde, nous donnons vie à des idées audacieuses en développant des solutions et produits connectés, efficaces et durables pour répondre aux principaux défis qu'impose la transformation numérique à nos clients.",
          "para2": "Le seul moyen de nourrir l’innovation numérique et de la faire progresser étant de collaborer, nous avons mis en place un écosystème englobant clients, intégrateurs de systèmes, start-up et partenaires technologiques de pointe. Chaque projet commence par une question : comment pouvons-nous apporter une réponse rapide et adaptée au problème spécifique de ce client ?",
          "para3": "Grâce à cette approche collaborative, nous gagnons en vitesse et en agilité, et élargissons notre horizon d'innovation pour fournir à nos clients les nouvelles capacités dont ils ont besoin pour prospérer à l’ère de l’économie numérique."
        },
        "snapshot": {
          "title": "Focus : la R&D chez Schneider Electric en 2017",
          "cell1": {
            "title": "16 250",
            "para": "brevets ou dépôts de brevet"
          },
          "cell2": {
            "title": "670",
            "para": "nouveaux brevets actifs en 2017"
          },
          "cell3": {
            "title": "20+",
            "para": "services numérique en développement pour 2018"
          },
          "cell4": {
            "title": "5 %",
            "para": "du chiffre d'affaires dédié à la R&D"
          }
        },
        "txtmedia2": {
          "title": "Nos six fondements pour réussir à l'ère du numérique",
          "para1": "Schneider Electric mène la transformation numérique de la gestion de l’énergie et de l’automatisation grâce à : ",
          "listItem1": "Une architecture et plateforme IdO, EcoStruxure",
          "listItem2": "Une expertise historique à la périphérie du réseau, où les technologies opérationnelles et l’informatique convergent pour fournir des renseignements rapides et précis",
          "listItem3": "La gestion du cycle de vie numérique, c’est-à-dire que nous utilisons les progrès de l’IdO pour faire baisser les coûts et la complexité au stade de l’investissement (conception et élaboration) et de l’exploitation (fonctionnement et entretien) ",
          "listItem4": "Une expertise poussée du domaine et du segment de marché, qui nous permet de faire progresser la numérisation, lien entre l’expertise et la technologie, afin de résoudre les problèmes spécifiques des clients",
          "listItem5": "Un portefeuille robuste et dynamique de services numériques, qui décuple la valeur que nous proposons à nos clients via des services tels que Resource Advisor, pour suivre et améliorer les dépenses d’énergie, et Asset Advisor, pour améliorer la santé et la performance des actifs",
          "listItem6": "Un écosystème ouvert de partenaires, qui nous permet de dimensionner et d’accélérer la transformation numérique de chacun de nos clients en travaillant avec des partenaires technologiques de premier plan tels que Microsoft<sup>&reg;</sup>, Accenture<sup>&reg;</sup>, Intel<sup>&reg;</sup>, Cisco<sup>&reg;</sup> et Salesforce &mdash; ainsi que des universités, start-up, intégrateurs de systèmes et clients&mdash; pour développer rapidement des solutions numériques additionnelles"
        },
        "barometer": {
          "title": "Résultat du baromètre Planète & Société 2015 – 2017",
          "cta": "Voir l’ensemble des résultats.",
          "cell1": {
            "title": "Économie Circulaire",
            "stat": "100 %",
            "para": "des produits en R&D conçus avecSchneider Electric ecoDesign Way™"
          }
        },
        "table1": {
          "title": "Focus : alliances stratégiques dans le numérique",
          "row1": {
            "cell1": "Microsoft",
            "cell2": "Microsoft et Schneider Electric ont annoncé l'extension de leur partenariat et réafirmé leur engagement réciproque dans le déploiement de technologies disruptives. "
          },
          "row2": {
            "cell1": "Cisco",
            "cell2": "Schneider Electric et Cisco développent des architectures poussées d’automatisation sur divers marchés finaux, en combinant le leadership de Schneider Electric en matière de technologies opérationnelles et l’expertise de premier plan de Cisco en matière de réseaux et de solutions de communication."
          },
          "row3": {
            "cell1": "Intel",
            "cell2": "Soutenus financièrement par le ministère américain de l’Énergie, Schneider Electric et Intel mènent un programme de recherche, développement et commercialisation de solutions de cybersécurité sur silicium pour le réseau électrique."
          },
          "row4": {
            "cell1": "Salesforce",
            "cell2": "Schneider Electric et Salesforce travaillent de concert en capitalisant sur la connectivité et l’IdO afin de créer des expériences client plus marquantes."
          },
          "row5": {
            "cell1": "Accenture",
            "cell2": "Nous nous associons à Accenture pour réduire de 80 % les délais de développement et de mise sur le marché, afin que nos clients puissent réussir leur transformation numérique, pour plus d’efficacité, de durabilité et de productivité."
          }
        },
        "quote2": {
          "text": "La solution conçue par Schneider Electric est impressionnante (WaterForce SCADA farm), de même que les bénéfices qu’elle apporte à notre société.",
          "author": "Satya Nadella",
          "title": "CEO,",
          "company": "Microsoft, lors de l'édition 2017 de la conférence Microsoft Inspire"
        },
        "txtmedia3": {
          "title": "Co-innover avec nos partenaires dans le digital",
          "para1": "Fort de notre réseau d'acteurs leaders dans les technologies numériques, nous co-innovons en inventant des solutions numériques qui :",
          "listItem1": "répondent efficacement et rapidement aux tendances du marché et aux besoins des clients",
          "listItem2": "innovent de manière profitable pour le chiffre d'affaires ; il ne s'agit pas d’innover pour innover",
          "listItem3": "capitalisent sur les avancées technologiques telles que les capteurs, la mobilité, le cloud, les outils d’analyse et la cybersécurité, de sorte que les clients puissent non seulement rester dans la course, mais aussi se montrer compétitifs dans l’économie numérique"
        },
        "quote3": {
          "text": "Les renseignements issus de l’analyse des données aident Schneider Electric à mieux répondre aux besoins des clients, voire à les anticiper. Les nouveaux services numériques intelligents, tels que la maintenance prédictive, la surveillance des installations et l’optimisation énergétique, permettent aux clients de rendre leurs activités plus proactives et plus efficaces.",
          "author": "Jean Cabanes",
          "title": "Directeur Exécutif Automobile & équipements industriels,",
          "company": "Accenture"
        },
        "txtmedia4": {
          "title": "La Digital Services Factory, catalyseur d’innovation",
          "para1": "Les tendances de marché ne cessent d'évoluer. L'accélération du cycle de développement est essentielle pour aider les clients à rester dans la course et à se montrer compétitifs à l’ère de l’économie numérique. La réponse, la voici : la Digital Services Factory (DSF) de Schneider Electric, soutenue par Accenture. Constituée d’un ensemble de capacités réparties au sein des différentes équipes de Schneider Electric, la DSF est organisée de manière à accélérer la création de nouveaux services digitaux et produits connectés dans les différents domaines d'activité de Schneider Electric. ",
          "para2":"La DSF capitalise sur l’expertise de nos offres IoT & Numérique :",
          "listItem1": "Généralisation des capteurs",
          "listItem2": "Cybersécurité",
          "listItem3": "Collecte d’informations sur les appareils",
          "listItem4": "Outils d’analyse",
          "listItem5": "Services digitaux",
          "listItem6": "Contrôle critique à la périphérie"
        },
        "txt": {
          "title": "Le fonds d’investissement Aster Capital",
          "para1": "Nous investissons dans des start-up innovantes par l’intermédiaire d’Aster Capital, société de capital-risque de premier plan spécialisée dans les domaines de l’énergie, de la mobilité et de l’environnement. Aster Capital cible essentiellement les marchés les plus attractifs en matière d’innovation (Amérique du Nord, Chine, Europe, et Israël). Aster Capital a accompagné plus d’une cinquantaine de jeunes start-up depuis sa création.",
          "para2": "En 2017, dans le cadre de la stratégie d’innovation à la périphérie de Schneider Electric, Aster Capital a financé la conception d’un incubateur d’entreprises qui apportera au Groupe innovation et croissance. Cette initiative, qui permet aux collaborateurs de faire part de leurs idées, pose les bases de la croissance de Schneider Electric dans de nouveaux domaines clés."
        }
      }
    }
  }
}
</i18n>

<template>
  <div id="">
    <Hero :loResSrc="require('../../assets/img/sustainable/sustainable-solutions-research-development-hero-lowres.jpg')" :hiResSrc="require('../../assets/img/sustainable/sustainable-solutions-research-development-hero.jpg')" chapter="02" :section="$t('sustainable.section')" :title="$t('sustainable.title')" :grayBG="true" />

    <section class="m-b-12">
      <Quote :photo="require('../../assets/img/sustainable/sustainable-solutions-rnd-quote.jpg')" :name="$t('sustainable.research.quote1.author')" :title="$t('sustainable.research.quote1.title')">
        <div v-html="$t('sustainable.research.quote1.text')"></div>
      </Quote>
    </section>

    <section class="m-b-120 m-t-120">
      <TxtMedia>
        <h2 id="openinnovation" class="m-b-45" slot="main-content" v-html="$t('sustainable.research.txtmedia1.title')"></h2>
        <p slot="main-content" v-html="$t('sustainable.research.txtmedia1.para1')"></p>
        <p slot="main-content" v-html="$t('sustainable.research.txtmedia1.para2')"></p>
        <p slot="main-content" v-html="$t('sustainable.research.txtmedia1.para3')"></p>
        <div slot="sidebar" class="l-mw-360 l-center">
          <SvgContainer v-if="$i18n.locale === 'en'">
            <SSResearchIG class="scaling-svg" />
          </SvgContainer>
          <SvgContainer v-if="$i18n.locale === 'fr'">
            <SSResearchIGFR class="scaling-svg" />
          </SvgContainer>
        </div>
      </TxtMedia>
    </section>

    <hr>

    <section class="m-b-120 m-t-120">
      <Snapshot>
        <div slot="above">
          <h2 class="t-grey" v-html="$t('sustainable.research.snapshot.title')"></h2>
        </div>
        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 class="" v-html="$t('sustainable.research.snapshot.cell1.title')"></h4>
          <div class="t-hr t-hr--white"></div>
          <p v-html="$t('sustainable.research.snapshot.cell1.para')"></p>
        </SnapshotCard>
        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('sustainable.research.snapshot.cell2.title')"></h4>
          <div class="t-hr"></div>
          <p v-html="$t('sustainable.research.snapshot.cell2.para')"></p>
        </SnapshotCard>
        <SnapshotCard class="t-white" :bgimg="require('@/assets/img/sustainable/EcoStruxure_Machine_Advisor_PC_Screen.jpg')">
          <h4 class="t-green-light" v-html="$t('sustainable.research.snapshot.cell3.title')"></h4>
          <div class="t-hr"></div>
          <p v-html="$t('sustainable.research.snapshot.cell3.para')"></p>
        </SnapshotCard>
        <SnapshotCard>
          <h4 class="t-green-light" v-html="$t('sustainable.research.snapshot.cell4.title')"></h4>
          <div class="t-hr"></div>
          <p v-html="$t('sustainable.research.snapshot.cell4.para')"></p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <hr>

    <section class="m-b-120 m-t-120">
      <ImageFull class="m-b-80">

      </ImageFull>

      <TxtMedia>
        <div slot="main-content">
          <h2 id="digitalfoundations" class="" v-html="$t('sustainable.research.txtmedia2.title')"></h2>
          <p v-html="$t('sustainable.research.txtmedia2.para1')"></p>
          <ul>
            <li v-html="$t('sustainable.research.txtmedia2.listItem1')"></li>
            <li v-html="$t('sustainable.research.txtmedia2.listItem2')"></li>
            <li v-html="$t('sustainable.research.txtmedia2.listItem3')"></li>
            <li v-html="$t('sustainable.research.txtmedia2.listItem4')"></li>
            <li v-html="$t('sustainable.research.txtmedia2.listItem5')"></li>
            <li v-html="$t('sustainable.research.txtmedia2.listItem6')"></li>
          </ul>
        </div>
        <img slot="sidebar" src="@/assets/img/sustainable/sustainable-solutions-rnd-our-six-digital.jpg" />
      </Txtmedia>

    </section>

    <section class="l-bg-white l-section-pad">
        <div class="l-content">
          <div class="row">
            <div class="col-xs-14 col-xs-offset-2">
              <h2 id="digitalalliances" class="t-grey m-b-32" v-html="$t('sustainable.research.table1.title')"></h2>
            </div>
          </div>
        </div>
        <TxtMedia class="m-b-50">
          <img slot="sidebar" class="logo" src="../../assets/img/sustainable/sustainable-solutions-rnd-microsoft.png" />
          <div slot="main-content">
            <p v-html="$t('sustainable.research.table1.row1.cell2')"></p>
          </div>
        </TxtMedia>
        <TxtMedia class="m-b-50">
            <img slot="sidebar" class="logo-smaller" src="../../assets/img/sustainable/sustainable-solutions-rnd-cisco.png" />
          <div slot="main-content">
            <p v-html="$t('sustainable.research.table1.row2.cell2')"></p>
          </div>
        </TxtMedia>
        <TxtMedia class="m-b-50">
          <img slot="sidebar" class="logo-smaller" src="../../assets/img/sustainable/sustainable-solutions-rnd-intel.png" />
          <div slot="main-content">
            <p v-html="$t('sustainable.research.table1.row3.cell2')"></p>
          </div>
        </TxtMedia>
        <TxtMedia class="m-b-50">
          <img slot="sidebar" class="logo-smaller" src="../../assets/img/sustainable/sustainable-solutions-rnd-salesforce.png" />
          <div slot="main-content">
            <p v-html="$t('sustainable.research.table1.row4.cell2')"></p>
          </div>
        </TxtMedia>
        <TxtMedia class="m-b-50">
          <img slot="sidebar" class="logo-smaller" src="../../assets/img/sustainable/sustainable-solutions-rnd-accenture.png" />
          <div slot="main-content">
            <p v-html="$t('sustainable.research.table1.row5.cell2')"></p>
          </div>
        </TxtMedia>
    </section>

    <section class="m-b-120 m-t-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('sustainable.research.barometer.title')"></h2>
        <CTA slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('sustainable.research.barometer.cta')" target="_blank"/>
        <BarometerIndicator class="col-xs-18" :color="$root.sassVars.cGreenLight" :title="$t('sustainable.research.barometer.cell1.title')" :stat="$t('sustainable.research.barometer.cell1.stat')" :body="$t('sustainable.research.barometer.cell1.para')"/>
      </Barometer>
    </section>

    <section class="m-b-120">
      <Quote :name="$t('sustainable.research.quote2.author')" :title="$t('sustainable.research.quote2.title')" :company="$t('sustainable.research.quote2.company')" :photo="require('@/assets/img/sustainable/Satya-Nadella-Microsoft.jpg')">
        <div v-html="$t('sustainable.research.quote2.text')"></div>
      </Quote>
    </section>

    <section class="m-b-120 m-t-120">
      <TxtMedia>
        <h2 class="m-b-45" slot="main-content" v-html="$t('sustainable.research.txtmedia3.title')"></h2>
        <p slot="main-content" v-html="$t('sustainable.research.txtmedia3.para1')"></p>
        <ul slot="main-content">
          <li v-html="$t('sustainable.research.txtmedia3.listItem1')"></li>
          <li v-html="$t('sustainable.research.txtmedia3.listItem2')"></li>
          <li v-html="$t('sustainable.research.txtmedia3.listItem3')"></li>
        </ul>
        <img slot="sidebar" src="../../assets/img/sustainable/sustainable-solutions-rnd-open-innovation.jpg" />
      </TxtMedia>
    </section>

    <section class="m-t-120">
      <Quote :name="$t('sustainable.research.quote3.author')" :title="$t('sustainable.research.quote3.title')" :company="$t('sustainable.research.quote3.company')" :photo="require('@/assets/img/sustainable/Jean_Cabanes_Accenture.jpg')">
        <div v-html="$t('sustainable.research.quote3.text')"></div>
      </Quote>
    </section>

    <section class="m-b-120 l-section-pad l-bg-white">
      <ImageFull class="m-b-80">
        <img src="@/assets/img/sustainable/Power_Electronics_Lab1.jpg" />
      </ImageFull>
      <Txt>
        <h2 id="digitalservicesfactory" class="m-b-45" v-html="$t('sustainable.research.txtmedia4.title')"></h2>
        <p v-html="$t('sustainable.research.txtmedia4.para1')"></p>
        <p v-html="$t('sustainable.research.txtmedia4.para2')"></p>
        <ul>
          <li v-html="$t('sustainable.research.txtmedia4.listItem1')"></li>
          <li v-html="$t('sustainable.research.txtmedia4.listItem2')"></li>
          <li v-html="$t('sustainable.research.txtmedia4.listItem3')"></li>
          <li v-html="$t('sustainable.research.txtmedia4.listItem4')"></li>
          <li v-html="$t('sustainable.research.txtmedia4.listItem5')"></li>
          <li v-html="$t('sustainable.research.txtmedia4.listItem6')"></li>
        </ul>
      </Txt>
    </section>

    <section class="m-b-120 m-t-120">
      <TxtMedia>
        <div slot="main-content">
          <h2 id="astercapital" v-html="$t('sustainable.research.txt.title')"></h2>
          <p v-html="$t('sustainable.research.txt.para1')"></p>
          <p v-html="$t('sustainable.research.txt.para2')"></p>
        </div>
        <img slot="sidebar" src="@/assets/img/sustainable/sustainable-solutions-rnd-digital-services-factory.jpg" />
      </TxtMedia>
    </section>

    <div class="l-content">
      <FooterNav
        nextRoute="SustainableSolutions_EnergyUniversity"
        prevRoute="SustainableSolutions_EnergyServices" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import TxtMedia from '@/components/TxtMedia'
import Txt from '@/components/Txt'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'
import Barometer from '@/components/Barometer'
import BarometerIndicator from '@/components/BarometerIndicator'
import Table from '@/components/Table'
import TableRow from '@/components/TableRow'
import TableCell from '@/components/TableCell'
import SvgContainer from '@/components/SvgContainer'
import ImageFull from '@/components/ImageFull'

import SSResearchIG from '@/assets/img/ig/sustainable-solutions-rnd-coinnovating.svg'
import SSResearchIGFR from '@/assets/img/ig/sustainable-solutions-rnd-coinnovating_french.svg'

export default {
  name: 'Introduction_Welcome',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    TxtMedia,
    Snapshot,
    SnapshotCard,
    Barometer,
    BarometerIndicator,
    Table,
    TableRow,
    TableCell,
    SvgContainer,
    SSResearchIG,
    SSResearchIGFR,
    ImageFull
  }
}
</script>

<style lang="scss">
@import '../../scss/vars';
@import '../../scss/mixins';

.se-tablecell__content img.logo {
  width: 100%;
  max-width: 100px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/sustainable-solutions/research.vue